// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICoverageDto
 */
export interface ICoverageDto {
    /**
     * 
     * @type {number}
     * @memberof ICoverageDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICoverageDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICoverageDto
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof ICoverageDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICoverageDto
     */
    organization_path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ICoverageDto
     */
    is_default?: boolean;
}

/**
 * Check if a given object implements the ICoverageDto interface.
 */
export function instanceOfICoverageDto(value: object): value is ICoverageDto {
    return true;
}

export function ICoverageDtoFromJSON(json: any): ICoverageDto {
    return ICoverageDtoFromJSONTyped(json, false);
}

export function ICoverageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICoverageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
    };
}

export function ICoverageDtoToJSON(json: any): ICoverageDto {
    return ICoverageDtoToJSONTyped(json, false);
}

export function ICoverageDtoToJSONTyped(value?: ICoverageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'is_default': value['is_default'],
    };
}

